import './manual-sync.scss';
import './manual-sync-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/manual-sync/index.js